/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Possible periods of standing order execution.
 * - RECURRENT - interval which period is specified in intervalDescription.
 * - IRREGULAR - must have specified a list of months when execution is allowed.
 *
 */
export enum StandingOrderExecutionInterval {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    BI_MONTHLY = 'BI_MONTHLY',
    QUARTERLY = 'QUARTERLY',
    HALFYEARLY = 'HALFYEARLY',
    YEARLY = 'YEARLY',
    IRREGULAR = 'IRREGULAR',
    RECURRENT = 'RECURRENT',
}
